import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  ValidateNestleOwners,
  ValidateNestleOwnersValidation,
} from './ValidateNestleOwners';

export const ValidateNestleOwnersFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ValidateNestleOwners',
    component: ValidateNestleOwners,
    validation: ValidateNestleOwnersValidation,
  }),
);
